import React from 'react';
import CourseTile from './CourseTile';
import './tiles.scss';

function CourseTileHolder({ tileContents }) {
    // Use optimized images from public directory for better performance
    const images = [
        "/assets/images/optimized/Training/image1-medium.jpeg",
        "/assets/images/optimized/Training/image2-medium.jpeg",
        "/assets/images/optimized/Training/image3-medium.jpeg",
        "/assets/images/optimized/Training/image4-medium.jpeg",
        "/assets/images/optimized/Training/image5-medium.jpeg",
        "/assets/images/optimized/Training/image6-medium.jpeg",
        "/assets/images/optimized/Training/image7-medium.jpeg",
        "/assets/images/optimized/Training/image8-medium.jpeg",
        "/assets/images/optimized/Training/image9-medium.jpeg",
        "/assets/images/optimized/Training/image10-medium.jpeg"
    ];

    const coursesWithImages = tileContents.map((course, index) => ({
        ...course,
        image: images[index % images.length],
    }));

    return (
        <div className="tile-holder">
            {coursesWithImages.length > 0 ? (
                coursesWithImages.map((course) => (
                    <CourseTile key={course.id || course.code} {...course} />
                ))
            ) : (
                <div className="no-courses">
                    <p>No courses found in this category.</p>
                </div>
            )}
        </div>
    );
}

export default CourseTileHolder;
